// import '../Scss/Frontend/Elements/InstaFeed.scss';
import $ from 'jquery';
import Instafeed from 'instafeed.js';

(function () {
	if($('#instafeed').length) {
		var feed = new Instafeed({
			accessToken: 'IGQVJVS2xyZA2tNVzZAlTmFZAOHEzUHRqeDVKNlhmVS1CQmNkcHN2TTJzTlJzMTFDQWt3Y092dkd1NUEtcVpjRmUtUDBQazJSUW1iLWtvbEhQdzlJQWhJOC1YcWVNVFZAHSExYRWJfRmVB',
			template: '<div class="image"><a href="{{link}}" target="_blank" id="{{id}}"><img src="{{image}}" /></a><p>{{caption}}</p></div>',
			sortBy: 'most-recent',
			limit: 3
		});
		  feed.run();
	}
})();
